import {
    PORTFOLIO_SUMMARY_REQUEST,
    PORTFOLIO_SUMMARY_ERROR,
    PORTFOLIO_SUMMARY_SUCCESS,
    INVESTMENT_SUMMARY_REQUEST,INVESTMENT_SUMMARY_SUCCESS,INVESTMENT_SUMMARY_ERROR,
    CASH_LEDGER_REQUEST,CASH_LEDGER_SUCCESS,CASH_LEDGER_ERROR,
    WITHDRAW_MONEY,
    WITHDRAW_MONEY_SUCCESS,
    WITHDRAW_MONEY_ERROR,
    ADD_MONEY,
    ADD_MONEY_SUCCESS,
    ADD_MONEY_ERROR,
    REFER_EARN_REQUEST,
    REFER_EARN_ERROR,
    REFER_EARN_SUCCESS,
    FETCH_BORROWER_DETAILS,
    FETCH_BORROWER_DETAILS_SUCCESS,
    FETCH_BORROWER_DETAILS_ERROR,
    SELECT_TENURE_VALUE,
    RESET_WITHDRAWAL_AMOUNT,
    ADD_AMOUNT_VALUE
} from "./actionsTypes";

const initialState = {
    isLoading: true,
    dashboardSummary: null,
    dashboardSummaryError:null,
    investmentSummary:null,
    investmentSummaryError:null,
    cashLedgerSummary:null,
    cashLedgerSummaryError:null,
    userStatus: null,
    error: {},
    withdrawAmount: 10000,
    withdrawResponse: null,
    withdrawalError: null,
    addMoneySummary: null,
    addMoneyError: null,
    referEarnData:null,
    referEarnError:null,
    addPaymentGateway:null,
    borrowerResponse: null,
    borrowerError:null,
    tenureValue:null,
    amountInput:null
};

const dashboardReducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {
        case PORTFOLIO_SUMMARY_REQUEST:
            return {
                ...state,
                isLoading: false,
                dashboardSummary: payload,
            }
        case PORTFOLIO_SUMMARY_ERROR:
            return {
                ...state,
                isLoading: false,
                dashboardSummaryError:payload
            }
        case PORTFOLIO_SUMMARY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                dashboardSummary: payload
            }
        case INVESTMENT_SUMMARY_REQUEST:
            return {
                ...state,
                investmentSummary:payload
            }
        case INVESTMENT_SUMMARY_SUCCESS:
            return {
                ...state,
                investmentSummary:payload,
                // 
            }
        case INVESTMENT_SUMMARY_ERROR:
            return {
                ...state,
                investmentSummaryError:payload
            }

            case CASH_LEDGER_REQUEST:
            return {
                ...state,
                cashLedgerSummary:payload
            }
        case CASH_LEDGER_SUCCESS:
            return {
                ...state,
                cashLedgerSummary:payload
            }
        case FETCH_BORROWER_DETAILS:
            return {
                ...state,
                // borrowerResponse:payload
            }
        case FETCH_BORROWER_DETAILS_SUCCESS:
            return {
                ...state,
                borrowerResponse:payload
            }
        case FETCH_BORROWER_DETAILS_ERROR:
            return {
                ...state,
                borrowerError:payload
            }
        case CASH_LEDGER_ERROR:
            return {
                ...state,
                cashLedgerSummaryError:payload
            }
        case ADD_MONEY:
            return {
                ...state,
                isLoading: false
            }
        case ADD_MONEY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                addMoneySummary: payload
            }
        case ADD_MONEY_ERROR:
            return {
                ...state,
                isLoading: false,
                addMoneyError: payload
            }
        case WITHDRAW_MONEY:
            return {
                ...state,
                isLoading: false,

            }
        case WITHDRAW_MONEY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                withdrawResponse: payload
            }
        case WITHDRAW_MONEY_ERROR:
            return {
                ...state,
                isLoading: false,
                withdrawalError: payload
            }

        case REFER_EARN_REQUEST:
            return {
                ...state,
                isLoading: false,
            }
        case REFER_EARN_ERROR:
            return {
                ...state,
                isLoading: false,
                referEarnError: payload,
            }
        case REFER_EARN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                referEarnData: payload
            }
        case SELECT_TENURE_VALUE:
            return {
                ...state,
                tenureValue: payload
            }
        case RESET_WITHDRAWAL_AMOUNT:
            return {
                ...state,
                withdrawResponse: null
            }

        case ADD_AMOUNT_VALUE:
        return {
        ...state,
        amountInput: payload
        }

        default:
            return state;
    }
}

export default dashboardReducer;